import { PostProcessingConfig } from '@scale/shared-types';
import { PostProcessingConfigSchema } from '@scale/shared/pipelinev3/contentUnderstanding/paramsSchema';
import React from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Button } from '@scale/scaleui';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface PostProcessingConfigsBuilderProps {
  name: string;
  existingValue?: Array<PostProcessingConfig>;
  updateProperty: (arg: Array<PostProcessingConfig> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const PostProcessingConfigsBuilder: React.FC<PostProcessingConfigsBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const configs = existingValue;

  const addConfig = () => {
    const newConfigs = [...configs];
    newConfigs.push({
      model: 'gpt-3.5-turbo',
      prompt: `
      Here are two versions of a piece of text, one is an unprocessed copy and the second is a copy of the same text that has been edited to fix spelling and grammar errors only if they exist. If there are no errors the text remains the same.
      
      Example Input: Inher33ent Risk:
      Example Output: Inherent Risk:
      
      Input: {{value}}
      Output:
      `,
      fieldId: 'field_id',
      maxTokens: 4096,
      temperature: 0.0,
    });
    updateProperty(newConfigs);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-lg">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={configs}
        setElements={updateProperty}
        getKey={config => `${config.model}-${config.fieldId}`}
        getTitle={config => `${config.model}`}
        getSchema={_ => PostProcessingConfigSchema}
      />
      <Button onClick={() => addConfig()}>Add Post Processing Config</Button>
    </div>
  );
};

export default PostProcessingConfigsBuilder;
